import { DetailsLinkTypeEnum } from '@mwe/constants';

export abstract class DetailsLinkTypeEnumExporter {
  public get detailsLinkTypeEnum(): typeof DetailsLinkTypeEnum {
    return DetailsLinkTypeEnum;
  }
}
